import {Model} from "./Model";
import {IApiRosterHistoryEvent, IApiRosterHistoryEventAction} from "../typings/apiResponse";

export class RosterHistoryEvent extends Model {

    constructor(private apiData: IApiRosterHistoryEvent) {
        super(apiData);
    }

    /**
     * Gets the User ID of the user who is related to the event.
     * @returns {number}
     */
    public getUserId(): number {
        return this.apiData.userId;
    }

    /**
     * Gets the action that is related to the event.
     * @returns {IApiRosterHistoryEventAction} either 'join' or 'leave', as typed in IApiRosterHistoryEventAction
     */
    public getAction(): IApiRosterHistoryEventAction {
        return this.apiData.action;
    }

    /**
     * Gets the date of the event as localized Date object.
     * @returns {Date}
     */
    public getDate(): Date {
        return new Date(this.apiData.date);
    }
}
